module.exports = __webpack_public_path__ + "img/horizontal_7_5_2.f0b1f564.png";